import { ThemeContext } from '@f_context/Theme_context';
import stls from '@f_styles/components/licenses/Licenses.module.sass';
import InfoIcon from '@mui/icons-material/Info';
import LaunchIcon from '@mui/icons-material/Launch';
import WarningIcon from '@mui/icons-material/Warning';
import { Alert, Box, Button, Card, CardContent, Typography } from '@mui/material';
import { useContext } from 'react';

const NEW_APP_URL = 'https://web.qwep.ru/';

export function MigratedNoticePage() {
    const { colors } = useContext(ThemeContext);

    return (
        <Box className={stls.subscriptionBox}>
            <div style={{ marginTop: '56px', marginBottom: '32px' }}>
                <Card
                    sx={{
                        background: `linear-gradient(135deg, ${colors.psi} 0%, ${colors.omega} 100%)`,
                        border: `2px solid ${colors.alpha}`,
                        borderRadius: 3,
                        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
                        overflow: 'visible',
                        position: 'relative',
                        maxWidth: '740px',
                        margin: '0 auto',
                    }}>
                    <CardContent sx={{ p: 4 }}>
                        <Box
                            sx={{
                                position: 'absolute',
                                top: -40,
                                left: 40,
                                background: colors.alpha,
                                borderRadius: '50%',
                                width: 100,
                                height: 100,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
                            }}>
                            <WarningIcon sx={{ color: '#fff', fontSize: 40 }} />
                        </Box>

                        <Typography
                            variant="h4"
                            sx={{
                                color: colors.alpha,
                                fontWeight: 'bold',
                                mb: 3,
                                mt: 2,
                                textAlign: 'center',
                            }}>
                            Обновление системы
                        </Typography>

                        <Alert
                            severity="info"
                            icon={<InfoIcon />}
                            sx={{
                                mb: 3,
                                background: 'rgba(33, 150, 243, 0.1)',
                                border: '1px solid rgba(33, 150, 243, 0.3)',
                                '& .MuiAlert-message': {
                                    color: colors.omicron,
                                },
                            }}>
                            <Typography variant="body1" sx={{ mb: 2, fontWeight: 600 }}>
                                Уважаемый пользователь!
                            </Typography>
                            <Typography variant="body1" sx={{ mb: 2 }}>
                                Приносим извинения за доставленные неудобства — мы знаем, что смена привычного
                                интерфейса может вызвать вопросы, и благодарим вас за понимание.
                            </Typography>
                            <Typography variant="body1" sx={{ mb: 2 }}>
                                Ваша компания уже автоматически перенесена в новую версию QWEP. Логин и пароль, а также
                                все добавленные поставщики сохранены и доступны в обновлённом приложении — вам не нужно
                                настраивать всё заново.
                            </Typography>
                            <Typography variant="body1" sx={{ mb: 2 }}>
                                Поддержка текущей версии прекращена. Чтобы продолжить работу, перейдите в новое
                                приложение по кнопке ниже.
                            </Typography>
                            <Box sx={{ textAlign: 'center', mt: 3 }}>
                                <Button
                                    variant="contained"
                                    size="large"
                                    href={NEW_APP_URL}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    startIcon={<LaunchIcon sx={{ width: '2.5rem', height: '2.5rem' }} />}
                                    sx={{
                                        background: `linear-gradient(45deg, ${colors.alpha} 30%, ${colors.beta} 90%)`,
                                        borderRadius: 2,
                                        px: 4,
                                        py: 2.5,
                                        width: '100%',
                                        fontSize: '1.8rem',
                                        fontWeight: 'bold',
                                        textTransform: 'none',
                                        boxShadow: '0 4px 15px rgba(0, 0, 0, 0.2)',
                                        '&:hover': {
                                            background: `linear-gradient(45deg, ${colors.beta} 30%, ${colors.alpha} 90%)`,
                                            transform: 'translateY(-2px)',
                                            boxShadow: '0 6px 20px rgba(0, 0, 0, 0.3)',
                                        },
                                        transition: 'all 0.3s ease',
                                    }}>
                                    Перейти в новое приложение
                                </Button>
                            </Box>
                        </Alert>
                    </CardContent>
                </Card>
            </div>
        </Box>
    );
}
